/* Zareen Jewels — Header behaviour: sticky hide/show, mega panel, drawer, search with live suggestions */
(() => {
  const init = (section) => {
    const root = section.querySelector('[data-zjh]');
    if (!root || root.dataset.zjhReady) return;
    root.dataset.zjhReady = '1';

    const html = document.documentElement;
    const desktop = window.matchMedia('(min-width: 990px)');
    const scrim = section.querySelector('[data-zjh-scrim]');

    /* ---------- sticky: hide on scroll down, reveal on scroll up ---------- */
    const sticky = root.dataset.sticky !== 'false';
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      section.classList.toggle('zjh-scrolled', y > 8);
      if (!sticky || html.classList.contains('zj-lock') || mega?.classList.contains('is-open') || section.querySelector('#cart-notification.active')) { lastY = y; return; }
      const barH = root.offsetHeight;
      if (y > lastY + 4 && y > barH * 3) section.classList.add('zjh-hidden');
      else if (y < lastY - 4 || y <= barH) section.classList.remove('zjh-hidden');
      lastY = y;
    };
    window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
    /* bag popup lives inside the header: bring the header back whenever an item is added, so the popup is visible and tappable */
    const showForBag = () => { section.classList.remove('zjh-hidden'); lastY = window.scrollY; };
    document.addEventListener('zj:cart-added', showForBag);

    /* ---------- mega panel ---------- */
    const mega = root.querySelector('[data-zjh-mega]');
    const trigger = root.querySelector('[data-zjh-mega-trigger]');
    let openT = 0, closeT = 0;
    const setMega = (open) => {
      if (!mega || !trigger) return;
      clearTimeout(openT); clearTimeout(closeT);
      mega.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      scrim && scrim.classList.toggle('is-on', open);
    };
    if (mega && trigger) {
      const hoverable = window.matchMedia('(hover: hover)');
      trigger.addEventListener('click', () => setMega(!mega.classList.contains('is-open')));
      [trigger, mega].forEach((el) => {
        el.addEventListener('mouseenter', () => { if (!hoverable.matches || !desktop.matches) return; clearTimeout(closeT); openT = setTimeout(() => setMega(true), 90); });
        el.addEventListener('mouseleave', () => { if (!hoverable.matches) return; clearTimeout(openT); closeT = setTimeout(() => setMega(false), 220); });
      });
      root.querySelectorAll('.zjh__nav-item').forEach((li) => {
        if (li.contains(trigger)) return;
        li.addEventListener('mouseenter', () => setMega(false));
      });
      scrim && scrim.addEventListener('click', () => setMega(false));
      mega.addEventListener('focusout', (e) => { if (!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) setMega(false); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && mega.classList.contains('is-open')) { setMega(false); trigger.focus(); } });
      desktop.addEventListener ? desktop.addEventListener('change', () => setMega(false)) : null;
    }

    /* ---------- dialogs: drawer + search ---------- */
    let active = null, returnTo = null;
    const focusables = (el) => [...el.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')].filter((n) => n.offsetParent !== null);

    const openPanel = (panel, opener) => {
      if (!panel) return;
      if (active) closePanel(true);
      setMega(false);
      active = panel;
      returnTo = opener || document.activeElement;
      panel.hidden = false;
      html.classList.add('zj-lock');
      section.classList.remove('zjh-hidden');
      section.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('is-open')));
      setTimeout(() => {
        const q = panel.querySelector('[data-zjh-q]');
        (q || focusables(panel)[0])?.focus({ preventScroll: true });
      }, 60);
    };
    const closePanel = (instant) => {
      if (!active) return;
      const panel = active;
      active = null;
      panel.classList.remove('is-open');
      section.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      html.classList.remove('zj-lock');
      const done = () => { if (!panel.classList.contains('is-open')) panel.hidden = true; };
      instant ? done() : setTimeout(done, 480);
      returnTo && returnTo.focus && returnTo.focus({ preventScroll: true });
    };

    section.querySelectorAll('[data-zjh-open]').forEach((btn) => {
      btn.addEventListener('click', () => openPanel(document.getElementById(btn.dataset.zjhOpen), btn));
    });
    section.querySelectorAll('[data-zjh-panel]').forEach((panel) => {
      panel.addEventListener('click', (e) => { if (e.target.closest('[data-zjh-close]')) closePanel(); });
      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
        if (e.key !== 'Tab') return;
        const f = focusables(panel);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    });
    desktop.addEventListener && desktop.addEventListener('change', (e) => { if (e.matches && active && active.classList.contains('zjh-drawer')) closePanel(true); });

    /* drawer family toggle */
    section.querySelectorAll('.zjh-drawer__toggle').forEach((toggle) => {
      const tabs = [...toggle.querySelectorAll('[role="tab"]')];
      const pick = (tab) => {
        toggle.dataset.active = tab.dataset.group;
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => pick(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          pick(n); n.focus();
        });
      });
    });

    /* ---------- live search suggestions ---------- */
    const search = section.querySelector('[data-zjh-search]');
    if (search) {
      const input = search.querySelector('[data-zjh-q]');
      const out = search.querySelector('[data-zjh-results]');
      const popular = search.querySelector('[data-zjh-popular]');
      const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      const searchUrl = search.querySelector('form').getAttribute('action');
      let timer = 0, ctrl = null;
      const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      const money = (v) => {
        const n = Number(String(v).replace(/[^\d.]/g, ''));
        return isNaN(n) ? '' : `Rs. ${n.toLocaleString('en-PK', { maximumFractionDigits: 0 })}`;
      };
      const sized = (url) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=160' : '');

      const render = (q, products) => {
        if (!products.length) {
          out.innerHTML = `<p class="zjh-res__empty">Nothing sparkles for “${esc(q)}” yet — try “set”, “ring” or “earrings”.</p>`;
          return;
        }
        out.innerHTML =
          `<p class="zjh__eyebrow">Pieces</p><ul class="zjh-res-list" role="list">` +
          products
            .map((p) => `<li><a class="zjh-res" href="${esc(p.url)}">
              ${p.image ? `<img class="zjh-res__img" src="${esc(sized(p.image))}" alt="" loading="lazy" width="64" height="76">` : '<span class="zjh-res__img"></span>'}
              <span class="zjh-res__title">${esc(p.title)}</span>
              <span class="zjh-res__price">${esc(money(p.price))}</span></a></li>`)
            .join('') +
          `</ul><a class="zjh-res__all" href="${esc(searchUrl)}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last">See all results for “${esc(q)}”</a>`;
      };

      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { out.innerHTML = ''; popular.hidden = false; return; }
        popular.hidden = true;
        out.innerHTML = '<div class="zjh-res__loading"></div>';
        timer = setTimeout(async () => {
          ctrl && ctrl.abort();
          ctrl = new AbortController();
          try {
            const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
            const res = await fetch(url, { signal: ctrl.signal });
            const data = await res.json();
            if (input.value.trim() !== q) return;
            render(q, (data.resources && data.resources.results && data.resources.results.products) || []);
          } catch (err) {
            if (err.name !== 'AbortError') out.innerHTML = '';
          }
        }, 220);
      });
    }

    onScroll();
  };

  const boot = (scope) => scope.querySelectorAll('.zj-header-section').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => { if (e.target.classList.contains('zj-header-section')) init(e.target); });
})();
